import { render } from "./instagram.vue?vue&type=template&id=26409430&scoped=true"
import script from "./instagram.vue?vue&type=script&lang=js"
export * from "./instagram.vue?vue&type=script&lang=js"

import "./instagram.vue?vue&type=style&index=0&id=26409430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26409430"]])

export default __exports__